/**
 * Updates a tour's editable info fields (name, address, description, contact).
 *
 * Routes through the gen2 tourCollaborators GCF (`action: 'updateTourInfo'`)
 * instead of the legacy v1 `tours-updateTour` callable so collaborators —
 * not just the creator — can save changes. Server-side authorization
 * accepts caller iff they're the creator OR in collaboratorAuthUids.
 */

import { callCollaboratorsApi } from './collaboratorsApi';

export interface TourContactInfo {
  name: string;
  title: string;
  email: string;
  phone: string;
  photo: string;
  logo: string;
  website: string;
}

export interface UpdateTourInfoPayload {
  tourId: string;
  name: string;
  address: string;
  description: string;
  contactInfo: TourContactInfo;
}

export async function updateTourInfo(
  payload: UpdateTourInfoPayload,
): Promise<void> {
  await callCollaboratorsApi<{ success: boolean }>({
    action: 'updateTourInfo',
    ...payload,
  });
}
